import * as _ from 'lodash';
import * as moment from 'moment/moment';
import { AbstractApiModel } from './abstract-api-model';
import { Heartbeat } from './heartbeat';
import { RobotEvent } from './robot-event';

export class RobotEscalation extends AbstractApiModel<RobotEscalation> {
  robotName: string;
  robotId: number;
  storeId: number;
  storeName: string;
  organizationName: string;
  solution: string;
  status: string;
  snoozeUntil: Date;
  jobType: string;
  level: number;
  priority: number;
  resolvedAt: Date;
  resolvedBy: number;
  assignedAt: Date;
  assignedTo: number;
  assignedToEmail: string;
  batteryPct: number;
  lifecycleState: string;
  fullControlStatus: string;
  latestHeartbeat: Heartbeat;

  events: RobotEvent[];
  alertTooltip: string;


  deserialize(json: any): this {
    this.robotId = json.robot.id;
    this.robotName = json.robot.name;
    this.solution = json.robot.solution;
    this.storeId = json.store.id;
    this.storeName = json.store.name;
    this.organizationName = json.store.organization.name;
    this.status = json.status;
    this.snoozeUntil = json.snooze_until && new Date(json.snooze_until);
    this.jobType = json.job_type;
    this.level = json.level;
    this.priority = json.priority;
    this.resolvedAt = json.resolved_at && new Date(json.resolved_at);
    this.resolvedBy = json.resolved_by;
    this.assignedAt = json.assigned_at && new Date(json.assigned_at);
    this.assignedTo = json.assigned_to;
    this.lifecycleState = json.robot.lifecycle_state;
    this.fullControlStatus = json.latest_heartbeat?.data?.control.status;
    this.batteryPct = json.latest_heartbeat?.battery_pct;
    this.events = json.events && json.events.map(event => new RobotEvent().deserialize(event));
    if (this.events) {
      this.alertTooltip = _.sortBy(this.events, 'createdAt').map((event: RobotEvent) =>
        `${event.message} (${moment.duration(+new Date() - +event.createdAt).format()} ago)`).join('\n');
    }
    this.latestHeartbeat = json.latest_heartbeat && new Heartbeat().deserialize(json.latest_heartbeat);

    return super.deserialize(json);
  }

  serialize(): any {
    console.log('serialize this.snoozeUntil:', this.snoozeUntil);
    return Object.assign(super.serialize(), {
      status: this.status,
      assigned_to: this.assignedTo || '',
      snooze_until: this.snoozeUntil
    });
  }

}
